import React from 'react';
import { Box } from 'edenred-ui';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

import {
  SwitchElement,
  SwitchSlider
} from '@epi-pages/LoadBenefit/components/Topup/TopupForm/TopupSwitch/TopupSwitch.styles';

interface GeneralSettingsSwitchProps {
  checked: boolean;
  toggleChecked: () => void;
  disabled?: boolean;
}

const GeneralSettingsSwitch = ({
  checked,
  toggleChecked,
  disabled
}: GeneralSettingsSwitchProps) => {
  const { t } = useTranslation();
  const { sizeMedium, fontSemiBold } = useTheme();

  const handleClick = () => {
    if (disabled) {
      return null;
    }
    toggleChecked();
  };

  return (
    <Box display="flex" gap={1} alignItems="center">
      <SwitchElement id="switch-lunch-general-settings">
        <SwitchSlider
          onClick={handleClick}
          checked={checked}
          disabled={disabled}
        />
      </SwitchElement>
      <Box fontSize={sizeMedium} fontWeight={fontSemiBold}>
        {t('containers.benefit_groups.general_settings')}
      </Box>
    </Box>
  );
};

export { GeneralSettingsSwitch };
